import { Redirect } from "react-router-dom";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import TenantRoleAssignmentManager from "components/TenantRoleAssignmentManager";
import { useAuthz } from "context/AuthzContext";
import { TC } from "../tokens/text";

function RoleAssignmentPage() {
  const { isSuperAdmin, isTenantAdmin } = useAuthz();

  if (!isSuperAdmin && !isTenantAdmin) {
    return <Redirect to="/unauthorized" />;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <VuiBox py={3}>
        <VuiTypography variant="lg" mb={2} sx={{ color: TC.primary }}>
          Role Assignment
        </VuiTypography>
        <TenantRoleAssignmentManager />
      </VuiBox>
      <Footer />
    </DashboardLayout>
  );
}

export default RoleAssignmentPage;


